import React from 'react';
import { Button } from '../ui/button';
import { Calendar, MessageCircle, ArrowRight, CheckCircle } from 'lucide-react';
import { closingContent, LINKS } from '../../data/mock';

const ClosingSection = () => {
  return (
    <section className="py-20 md:py-28 px-4 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-4xl mx-auto text-center">
        {/* Header */}
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
          {closingContent.title}
        </h2>
        <p className="text-gray-600 text-lg mb-12 max-w-2xl mx-auto">
          Elige la opción que mejor se adapte a ti
        </p>

        {/* Dual CTA Cards */}
        <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto">
          {/* Option A - Decididos */}
          <div className="bg-white rounded-3xl p-8 shadow-xl border-2 border-[#007AFF] relative overflow-hidden group hover:-translate-y-1 transition-all duration-300">
            <div className="absolute top-0 left-0 right-0 h-1 bg-[#007AFF]"></div>
            <div className="mb-6">
              <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-50 text-[#007AFF] text-sm font-medium">
                <CheckCircle className="w-4 h-4" />
                {closingContent.optionA.label}
              </span>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Quiero empezar ya</h3>
            <p className="text-gray-600 mb-6 text-sm">
              Agenda una sesión de implementación y ponemos en marcha tu sistema
            </p>
            <a href={LINKS.calendar} target="_blank" rel="noopener noreferrer" className="block">
              <Button 
                size="lg" 
                className="w-full bg-[#007AFF] hover:bg-[#0056b3] text-white py-6 font-bold rounded-xl shadow-lg shadow-blue-500/25 hover:shadow-xl transition-all duration-300 group"
              >
                <Calendar className="w-5 h-5 mr-2" />
                {closingContent.optionA.button}
                <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
            </a>
          </div>

          {/* Option B - Dudas */}
          <div className="bg-white rounded-3xl p-8 shadow-lg border border-gray-200 relative overflow-hidden group hover:-translate-y-1 transition-all duration-300">
            <div className="absolute top-0 left-0 right-0 h-1 bg-[#25D366]"></div>
            <div className="mb-6">
              <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-green-50 text-[#25D366] text-sm font-medium">
                <MessageCircle className="w-4 h-4" />
                {closingContent.optionB.label}
              </span>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Tengo preguntas</h3>
            <p className="text-gray-600 mb-6 text-sm">
              Escríbenos por WhatsApp y resolvemos todas tus dudas sin compromiso
            </p>
            <a href={LINKS.whatsapp} target="_blank" rel="noopener noreferrer" className="block">
              <Button 
                size="lg" 
                variant="outline"
                className="w-full border-2 border-[#25D366] text-[#25D366] hover:bg-[#25D366] hover:text-white py-6 font-bold rounded-xl transition-all duration-300 group"
              >
                <MessageCircle className="w-5 h-5 mr-2" />
                {closingContent.optionB.button}
              </Button>
            </a>
          </div>
        </div>

        {/* Trust note */}
        <p className="text-gray-400 text-sm mt-10">
          +120 clínicas ya confían en No-Show Killer
        </p>
      </div>
    </section>
  );
};

export default ClosingSection;
